import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import Box from '../box/box.jsx';
import {trConnectionModal} from '../debug-modal/sections/tr-messages';

import styles from './connection-modal.css';

// Türkçe içeriği kullanmak için TRUE değerini ayarlayın
const useTurkish = true;

class DeviceSelectionStep extends React.Component {
    constructor (props) {
        super(props);
        this.handleSelectDeviceType = this.handleSelectDeviceType.bind(this);
    }
    
    handleSelectDeviceType (deviceType) {
        this.props.onSelectDeviceType(deviceType);
    }
    
    render () {
        return (
            <Box className={styles.body}>
                <Box className={styles.activityArea}>
                    <div className={styles.deviceSelectionArea}>
                        <div className={styles.deviceTypeList}>
                            <div 
                                className={styles.deviceTypeItem}
                                onClick={() => this.handleSelectDeviceType('bluetooth')}
                            >
                                <div className={styles.deviceTypeItemInner}>
                                    <div className={styles.deviceTypeIcon}>
                                        <img 
                                            src={this.props.bluetoothIconURL || 'BLUETOOTH_ICON'}
                                            alt="Bluetooth"
                                        />
                                    </div>
                                    <div className={styles.deviceTypeName}>
                                        {useTurkish ? 'Bluetooth / WiFi Cihazları' : 'Bluetooth / WiFi Devices'}
                                    </div>
                                </div>
                            </div>
                            
                            <div 
                                className={styles.deviceTypeItem}
                                onClick={() => this.handleSelectDeviceType('serial')}
                            >
                                <div className={styles.deviceTypeItemInner}>
                                    <div className={styles.deviceTypeIcon}>
                                        <img 
                                            src={this.props.serialIconURL || 'SERIAL_ICON'}
                                            alt="Serial"
                                        />
                                    </div>
                                    <div className={styles.deviceTypeName}>
                                        {useTurkish ? 'Seri Port' : 'Serial Port'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Box>
            </Box>
        );
    }
}

DeviceSelectionStep.propTypes = {
    bluetoothIconURL: PropTypes.string,
    serialIconURL: PropTypes.string,
    onSelectDeviceType: PropTypes.func.isRequired
};

export default DeviceSelectionStep; 